import { Component, OnInit } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { NgClass, NgIf } from '@angular/common';
import { TranslationDirective } from '../../translata-modal/translation.directive';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../button/button.component';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-pep-dialog-box',
  templateUrl: './pep-dialog-box.component.html',
  styleUrls: ['./pep-dialog-box.component.scss'],
  imports: [NgIf, TranslationDirective, TranslateModule, ButtonComponent],
})
export class PepDialogBoxComponent {
  imagelang: string;
  pepConfirm: boolean = false;
  constructor(
    public dialogRef: DialogRef,
    private auth: AuthService
  ) {
    dialogRef.disableClose = true;
    this.imagelang = this.auth.user.lang;
  }
  changeBox() {
    this.pepConfirm = true;
  }
}
